// src/components/Avatar.jsx
// A person's round picture (3.22.2): their photo, the icon they picked, or
// their initials. avatar: { image } | { icon } | null
// 3.44.1: initials are two letters (first and last name) on the theme's
// two-tone gradient, like the main buttons; icons sit on a soft gradient of
// the theme's light shades. Both follow the theme and dark mode (palette
// variables).
export function initialsOf(name) {
  const parts = String(name || '').replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
  if (!parts.length) return '?';
  const first = parts[0][0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
}

export default function Avatar({ avatar, name, size = 30, style }) {
  const two = initialsOf(name);
  const box = {
    width: size, height: size, borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: avatar?.image ? 'var(--c-eceff1)'
      : avatar?.icon ? 'linear-gradient(135deg, var(--c-e0f2f1), var(--b-f1f8e9) 60%, var(--c-e3f2fd))'
        : 'linear-gradient(135deg, var(--c-00695c), var(--c-00897b) 45%, var(--c-26a69a) 70%, var(--b-43a047))',
    color: 'var(--t-ffffff)',
    boxShadow: avatar?.image ? 'none' : `inset 0 1px 0 rgb(var(--c-ffffff-rgb) / 0.35), 0 ${Math.max(1, Math.round(size / 16))}px ${Math.max(3, Math.round(size / 6))}px rgb(var(--c-00695c-rgb) / 0.25)`,
    fontWeight: 800, letterSpacing: two.length > 1 ? '-0.04em' : 0,
    textShadow: avatar?.icon ? 'none' : '0 1px 2px rgb(var(--c-000000-rgb) / 0.25)',
    fontSize: Math.round(size * (avatar?.icon ? 0.58 : two.length > 1 ? 0.38 : 0.44)), lineHeight: 1, ...style,
  };
  if (avatar?.image) return <span style={box} aria-hidden="true"><img src={avatar.image} alt="" width={size} height={size} style={{ display: 'block', objectFit: 'cover' }} /></span>;
  if (avatar?.icon) return <span style={box} aria-hidden="true">{avatar.icon}</span>;
  return <span style={box} aria-hidden="true">{two}</span>;
}
